import aiBlack from '../assets/eu-ai-labels/LABEL_AI_black.svg?url';
import aiWhite from '../assets/eu-ai-labels/LABEL_AI_white.svg?url';
import aiBlackTransparent from '../assets/eu-ai-labels/LABEL_AI_black transparent.svg?url';
import aiWhiteTransparent from '../assets/eu-ai-labels/LABEL_AI_white transparent.svg?url';
import generatedBlack from '../assets/eu-ai-labels/LABEL_AI GENERATED_black.svg?url';
import generatedWhite from '../assets/eu-ai-labels/LABEL_AI GENERATED_white.svg?url';
import generatedBlackTransparent from '../assets/eu-ai-labels/LABEL_AI GENERATED_black transparent.svg?url';
import generatedWhiteTransparent from '../assets/eu-ai-labels/LABEL_AI GENERATED_white transparent.svg?url';
import modifiedBlack from '../assets/eu-ai-labels/LABEL_AI MODIFIED_black.svg?url';
import modifiedWhite from '../assets/eu-ai-labels/LABEL_AI MODIFIED_white.svg?url';
import modifiedBlackTransparent from '../assets/eu-ai-labels/LABEL_AI MODIFIED_black transparent.svg?url';
import modifiedWhiteTransparent from '../assets/eu-ai-labels/LABEL_AI MODIFIED_white transparent.svg?url';

export const AI_LABEL_KINDS = [
  {
    id: 'basic',
    nameKey: 'aiLabelBasic',
    hintKey: 'aiLabelBasicHint',
    badgeHeight: 0.645,
    variants: {
      black: aiBlack,
      white: aiWhite,
      blackTransparent: aiBlackTransparent,
      whiteTransparent: aiWhiteTransparent,
    },
  },
  {
    id: 'generated',
    nameKey: 'aiLabelGenerated',
    hintKey: 'aiLabelGeneratedHint',
    badgeHeight: 0.47,
    variants: {
      black: generatedBlack,
      white: generatedWhite,
      blackTransparent: generatedBlackTransparent,
      whiteTransparent: generatedWhiteTransparent,
    },
  },
  {
    id: 'modified',
    nameKey: 'aiLabelModified',
    hintKey: 'aiLabelModifiedHint',
    badgeHeight: 0.47,
    variants: {
      black: modifiedBlack,
      white: modifiedWhite,
      blackTransparent: modifiedBlackTransparent,
      whiteTransparent: modifiedWhiteTransparent,
    },
  },
];

export const AI_LABEL_VARIANTS = [
  { id: 'black', nameKey: 'aiLabelVariantBlack' },
  { id: 'white', nameKey: 'aiLabelVariantWhite' },
  { id: 'blackTransparent', nameKey: 'aiLabelVariantBlackTransparent' },
  { id: 'whiteTransparent', nameKey: 'aiLabelVariantWhiteTransparent' },
];

export const AI_LABEL_SIZES = [
  { id: 'small', nameKey: 'aiLabelSizeSmall', ratio: 0.035 },
  { id: 'medium', nameKey: 'aiLabelSizeMedium', ratio: 0.05 },
  { id: 'large', nameKey: 'aiLabelSizeLarge', ratio: 0.07 },
];

const AI_LABEL_MIN_BADGE_PX = 20;

export const AI_LABEL_CORNERS = [
  { id: 'top-left', nameKey: 'aiLabelCornerTopLeft' },
  { id: 'top-right', nameKey: 'aiLabelCornerTopRight' },
  { id: 'bottom-left', nameKey: 'aiLabelCornerBottomLeft' },
  { id: 'bottom-right', nameKey: 'aiLabelCornerBottomRight' },
];

export const DEFAULT_AI_LABEL_OPTIONS = { size: 'medium', corner: 'top-right' };

export const createAiLabelPlacement =
  (kind, { size, corner } = DEFAULT_AI_LABEL_OPTIONS) =>
  (doc, natural) => {
    const shortSide = Math.min(doc.width, doc.height);
    const ratio = (AI_LABEL_SIZES.find((item) => item.id === size) || AI_LABEL_SIZES[1]).ratio;
    const badge = Math.min(Math.max(shortSide * ratio, AI_LABEL_MIN_BADGE_PX), shortSide * 0.3);
    const height = Math.round(badge / kind.badgeHeight);
    const width = Math.round((height * natural.width) / natural.height);
    const inset = Math.round(shortSide * 0.01);
    const left = corner.endsWith('left');
    const top = corner.startsWith('top');
    return {
      x: left ? inset + width / 2 : doc.width - inset - width / 2,
      y: top ? inset + height / 2 : doc.height - inset - height / 2,
      width,
      height,
    };
  };
